import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Import the component-specific styles
import logo from '../images/logo_with_name.png'; // Import the logo

// 1. Import the new MUI icons
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  return (
    // Converted HTML to JSX (class -> className, etc.)
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-section">
            {/* Use the imported logo variable */}
            <img alt="Iswaran Logo" className="logo-icon" src={logo} />
            <h3 className="footer-title">ISWARAN</h3>
            <p className="footer-description">Connecting you to your faith, digitally.</p>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/refund-policy" className="footer-link">Cancellation & Refund Policy</Link></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="footer-link">Terms of Service</Link></li>
              <li><Link to="/shipping-policy" className="footer-link">Shipping Policy</Link></li>

            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">Follow Us</h3>
            <div className="social-links">
              {/* 2. Replaced the <span> tags with the MUI icon components */}
              <a href="https://www.instagram.com/iswaran2026?utm_source=qr&igsh=MXdoaTA1aDdrZ2RsZQ==" target="_blank" rel="noopener noreferrer" className="social-link"><InstagramIcon className="social-icon" /></a>
              <a href="https://www.facebook.com/share/1TCrB3m2FB/" target="_blank" rel="noopener noreferrer" className="social-link"><FacebookIcon className="social-icon" /></a>
              <button type="button" className="social-link"><PhoneIcon className="social-icon" /></button>
              <button type="button" className="social-link"><EmailIcon className="social-icon" /></button>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-disclaimer">
            <strong>Important Disclaimer:</strong> Iswaran is an independent service provider and is not affiliated with any temple administration or government board. The charges collected include temple official fees, Pooja materials, priest offerings, logistics, and our service facilitation charges.
          </p>
          <p>© 2024 ISWARAN. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
